// extracted by mini-css-extract-plugin
export default {"container":"Sidebar_container__qDyE+","text":"Sidebar_text__7QE1k","logo":"Sidebar_logo__uAMHa"};